export default function TrainingWebinarDirective() {
  return {
    template: require('./training-webinar.html'),
    controller: 'TrainingWebinarController',
    controllerAs: 'trainingWebinarVM',
    bindToController: true,
    scope: {
      media: '=',
      filterText: '=',
    },
    replace: true,
  };
}
